import { ButtonFlavor, ButtonSize, ButtonType, ExButton, ExIcon } from '@boomi/exosphere';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useApp } from '../common/AppProvider';
import { translations } from '../translations/translations';

import './drawer.css';

const Drawer = ({
    isOpen,
    title,
    onClose,
    children,
}: {
    isOpen: boolean;
    title: string;
    onClose: () => void;
    children: ReactNode;
}) => {
    const { language } = useApp();
    const drawerClasses = classNames('ta-side-drawer custom-scrollbars', {
        'is-open': isOpen,
    });

    // Close the drawer if Esc key is pressed.
    useEffect(() => {
        const handleDrawerEsc = (e: KeyboardEvent) => e.key === 'Escape' && onClose();

        document.addEventListener('keydown', handleDrawerEsc);

        return () => {
            document.removeEventListener('keydown', handleDrawerEsc);
        };
    }, [onClose]);

    return (
        <div className={drawerClasses} aria-hidden={!isOpen} data-testid="taskEditorDrawer">
            <header className="drawer-header">
                <span className="title lg">{title}</span>
                <ExButton
                    data-testid="drawerCloseButton"
                    className="drawer-close-button"
                    flavor={ButtonFlavor.BRANDED}
                    size={ButtonSize.DEFAULT}
                    type={ButtonType.TERTIARY}
                    onClick={onClose}
                    title={translations[language].COMMON_close}
                >
                    <ExIcon className="drawer-close-icon" icon="Close" hide-browser-tooltip />
                </ExButton>
            </header>
            {children}
        </div>
    );
};

export default Drawer;
